import axios from 'axios';
import { GET_ALL_BOT_FORUM_STATS_FAIL, GET_ALL_BOT_FORUM_STATS_REQUEST, GET_ALL_BOT_FORUM_STATS_SUCCESS, GET_ALL_DATA_FAIL, GET_ALL_DATA_REQUEST, GET_ALL_DATA_SUCCESS, GET_ALL_USER_FORUM_STATS_REQUEST, GET_ALL_USERS_FAIL, GET_ALL_USERS_FORUM_STATS_FAIL, GET_ALL_USERS_REQUEST, GET_ALL_USERS_SUCCESS, GET_BLINDBOX_LIST_FAIL, GET_BLINDBOX_LIST_REQUEST, GET_BLINDBOX_LIST_SUCCESS, GET_BOT_FAIL, GET_BOT_REQUEST, GET_BOT_SUCCESS, GET_CERTIFICATES_LIST_FAIL, GET_CERTIFICATES_LIST_REQUEST, GET_CERTIFICATES_LIST_SUCCESS, GET_FILENAMES_FAIL, GET_FILENAMES_IUIU_FAIL, GET_FILENAMES_IUIU_REQUEST, GET_FILENAMES_IUIU_SUCCESS, GET_FILENAMES_REQUEST, GET_FILENAMES_SUCCESS, GET_MCQ_LIST_FAIL, GET_MCQ_LIST_REQUEST, GET_MCQ_LIST_SUCCESS } from '../constants/allData';

export const getUsers = () => async (dispatch) =>{
    dispatch({
        type: GET_ALL_USERS_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/users.json`);
        dispatch({type: GET_ALL_USERS_SUCCESS, payload: data });
        localStorage.setItem('users', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_ALL_USERS_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};



export const getUserForumStat = () => async (dispatch) =>{
    dispatch({
        type: GET_ALL_USER_FORUM_STATS_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/userForumStat.json`);
        dispatch({type: GET_ALL_BOT_FORUM_STATS_SUCCESS, payload: data});
        localStorage.setItem('userForumStat', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_ALL_USERS_FORUM_STATS_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};

export const getBot = () => async (dispatch) =>{
    dispatch({
        type: GET_BOT_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/bot.json`);
        dispatch({type: GET_BOT_SUCCESS, payload: data});
        localStorage.setItem('bot', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_BOT_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};

export const getBotForumStat = () => async (dispatch) =>{
    dispatch({
        type: GET_ALL_BOT_FORUM_STATS_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/botForumStat.json`);
        dispatch({type: GET_ALL_BOT_FORUM_STATS_SUCCESS, payload: data});
        localStorage.setItem('botForumStat', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_ALL_BOT_FORUM_STATS_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};

export const getFilenames = () => async (dispatch) =>{
    dispatch({
        type: GET_FILENAMES_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/filenames.json`);
        dispatch({type: GET_FILENAMES_SUCCESS, payload: data});
        localStorage.setItem('filenames', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_FILENAMES_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};

export const getFilenamesIuiu = () => async (dispatch) =>{
    dispatch({
        type: GET_FILENAMES_IUIU_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/filenamesIuiu.json`);
        dispatch({type: GET_FILENAMES_IUIU_SUCCESS, payload: data});
        localStorage.setItem('filenamesIuiu', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_FILENAMES_IUIU_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};

export const getCertificateList = () => async (dispatch) =>{
    dispatch({
        type: GET_CERTIFICATES_LIST_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/certificateList.json`);
        dispatch({type: GET_CERTIFICATES_LIST_SUCCESS, payload: data});
        localStorage.setItem('certificateList', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_CERTIFICATES_LIST_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};

export const getBlindboxList = () => async (dispatch) =>{
    dispatch({
        type: GET_BLINDBOX_LIST_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/blindboxList.json`);
        dispatch({type: GET_BLINDBOX_LIST_SUCCESS, payload: data});
        localStorage.setItem('blindboxList', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_BLINDBOX_LIST_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};

export const getMCQList = () => async (dispatch) =>{
    dispatch({
        type: GET_MCQ_LIST_REQUEST
    });
    try {
        const {data} = await axios.get(`${process.env.REACT_APP_STATIC_CDN}/json/mcq.json`);
        dispatch({type: GET_MCQ_LIST_SUCCESS, payload: data});
        localStorage.setItem('mcqList', JSON.stringify(data))
    } catch (error) {
        dispatch({type: GET_MCQ_LIST_FAIL, 
            payload: error.response 
            && error.response.data.message 
            ? error.response.data.message
            : error.message,});
    }
};
